import { axios } from '@/utils/request'
import ipConfig from '../../config/ip.config'
export const api = {
  getAnticipation: ipConfig.api_mwclg + '/mcp/user/getAnticipation',
  addAnticipation: ipConfig.api_mwclg + '/mcp/user/addAnticipation'
}

// 查询反馈建议
export function getAnticipation (params) {
  return axios({
    url: api.getAnticipation,
    method: 'post',
    data: params
  })
}
// 新增反馈建议
export function addAnticipation (params) {
  return axios({
    url: api.addAnticipation,
    method: 'post',
    data: params
  })
}
